import { useParams } from "react-router-dom";

import { ActivityFeed } from "~/providers/components/patientProfile/ActivityFeed";
import { PatientParams } from "~/providers/utils";

export const PatientActivityFeed = () => {
  const { patientId } = useParams<keyof PatientParams>() as PatientParams;

  return <ActivityFeed patientId={patientId} />;
};
